import { SelectedMapObject } from "@iventis/map-types/src/map-object-types";
import { EventStream } from "@iventis/utilities/src/event/stream";

export type MapUndoRedoSelectionEvent = { type: "mapObjectSelection"; payload: { oldSelection: SelectedMapObject[]; newSelection: SelectedMapObject[] } };

/** An event stream required for pushing to the map-related undo stack */
export const mapUndoRedoEventStream = new EventStream<MapUndoRedoSelectionEvent>();
